import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useMemo, useRef } from "react";
import CommentIcon from "@mui/icons-material/Comment.js";
import { useTheme, Typography } from "@mui/material";
import Box from "@mui/material/Box/index.js";
import SvgIcon from "@mui/material/SvgIcon/index.js";
import { WarningIcon } from "../../../../../components/icons/WarningIcon/WarningIcon.js";
import StyledTooltip from "../../../../../components/styled-tooltip/styled-tooltip.js";
import "@mui/material/styles";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { TIME_FORMATS } from "../../../../../constants/time/time.js";
import "lottie-react";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { differenceInMinutes, isPast, add, format } from "date-fns";
import "lodash";
import "../../../../components/appointments-picker/appointments-picker.styles.js";
import "clsx";
import "../../../../components/appointments-picker/components/AvailableSlot/AvailableSlot.styles.js";
import "../../../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.styles.js";
import "../../../../components/appointments-picker/components/NextPeriod/NextPeriod.styles.js";
import "../../../../components/appointments-picker/components/PrevPeriod/PrevPeriod.styles.js";
import "../../../../components/appointments-picker/components/QuickFilter/QuickFilter.styles.js";
import "../../../../components/appointments-picker/components/TimeFrames/TimeFrames.styles.js";
import "../../../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.styles.js";
import "../../../../components/appointments-picker/components/WorkingDay/WorkingDay.styles.js";
import "color-alpha";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../components/chemistry-info/chemistry-info.styles.js";
import "../../../../components/clinic-location-details/clinic-location-details.styles.js";
import "../../../../components/clinic-location-details/Day/styles.js";
import "../../../../components/clinic-location-details/Map/Map.js";
import "../../../../components/floating-button/floating-button-container/styles.js";
import "../../../../components/floating-button/floating-button.styles.js";
import "../../../../components/news-section/news-section.styles.js";
import { ObfuscatedText } from "../../../../components/obfuscated-text/obfuscated-text.js";
import "../../../../components/pain-details-form/pain-details-form.styles.js";
import "../../../../components/pain-details-form/constants/constants.js";
import "react-slick";
import "../../../../components/task-form/components/Avatar/Avatar.styles.js";
import "../../../../components/task-form/components/Comments/Comments.styles.js";
import "lodash/debounce.js";
import "../../../../components/task-form/components/DatePicker/DatePicker.styles.js";
import "../../../../components/task-form/components/EmployeeMenuItem/EmployeeMenuItem.styles.js";
import "../../../../components/task-form/components/EmployeesDropdown/EmployeesDropdown.styles.js";
import "../../../../components/task-form/components/PatientAutocomplete/PatientAutocomplete.styles.js";
import "@hookform/resolvers/yup";
import "../../../../components/task-form/task-form.entities.js";
import "../../../../components/task-form/task-form.styles.js";
import "../../../../components/task-form/theme/index.js";
import "../../../../components/team-section/constants/constants.js";
import "../../../../components/team-section/components/Rating/styles.js";
import "../../../../components/team-section/team-section.styles.js";
import "../../../../components/testimonials-section/constants.js";
import "../../../../components/testimonials-section/PractitionerTestimonialCard/styles.js";
import "../../../../components/testimonials-video-section/testimonials-video-section.styles.js";
import "../../../../components/employee-select/employee-select.js";
import "../../../../components/ana/utils/shared/Checkbox.js";
import "../../../../components/ana/utils/shared/FormControlLabel.js";
import "../../../../components/ana/components/translate/translate.js";
import "../../../../components/ana/components/checklist-input/checklist-input.styles.js";
import "react-dom";
import "../../../../components/ana/components/address-field/address-field.js";
import "../../../../components/ana/utils/hooks/useFormHelpers.js";
import "../../../../components/ana/utils/hooks/useSubmitCount.js";
import "../../../../components/ana/utils/yup/main.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.styles.js";
import "../../../../components/ana/components/date-picker-field/date-picker-field.js";
import "../../../../components/ana/components/phone-field/phone-field.js";
import "../../../../components/ana/components/radio-group/radio-group.js";
import "../../../../components/ana/utils/shared/TextFieldLabel.js";
import "../../../../components/ana/components/field-helper-text/field-helper-text.js";
import "../../../../components/ana/components/select-input/select-input.styles.js";
import "../../../../components/ana/components/text-input/text-input.js";
import "../../../../components/ana/components/toggle-field/toggle-field.js";
import "../../../../components/ana/utils/hooks/useFormValue.js";
import "../../../../components/ana/components/form-layout/form-layout.styles.js";
import "../../../../components/ana/utils/shared/Button.js";
import "../../../../components/ana/components/submit-button/submit-button.styles.js";
import "../../../../components/ana/components/toggle-multi-checkbox/toggle-multi-checkbox.styles.js";
import "../../../../components/ana/utils/config/diseases.js";
import "../../../../components/ana/utils/fields/allergiesAndMedications.js";
import "../../../../components/ana/components/insurance-field/insurance-field.js";
import "../../../../components/ana/utils/fields/insurance.js";
import "../../../../components/ana/utils/shared/SectionTitle.js";
import "yup";
import "../../../../components/ana/components/callout/Callout.styles.js";
import "../../../../components/ana/utils/types/contentful.js";
import "../../../../components/ana/utils/fields/contactDetails.js";
import "../../../../components/ana/utils/shared/AddressLayoutItem.js";
import "../../../../components/ana/forms/miscellaneous/miscellaneous.js";
import "../../../../components/ana-toolbox/ana-toolbox.js";
import "../../../../components/ana/utils/config/wishes.js";
import "../../../../components/ana/utils/shared/Radio.js";
import "../../../../components/ana/utils/shared/RadioFormControl.js";
import "../../../../components/ana/utils/shared/RadioFormControlLabel.js";
import "../../../../components/ana/utils/shared/RadioFormLabel.js";
import "../../../../components/ana/utils/shared/RadioGroup.js";
import "../../../../components/ana/utils/shared/ToggleContainer.js";
import "../../../../components/ana/utils/shared/ToggleFormControlLabel.js";
import "../../../../components/ana/forms/preconditions/preconditions.js";
import "../../../../components/ana/components/legal-representative-dialog/legal-representative-dialog.styles.js";
import "../../../../components/ana/utils/fields/personalInformation.js";
import "../../../../components/ana/utils/helpers/DiseaseType.js";
import "../../../../components/ana/utils/shared/TextField.js";
import "../../../../components/ana/components/tag/tag.styles.js";
import "../../../../components/ana/components/disease-field/disease-field.styles.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.styles.js";
import "../../../../components/ana/utils/helpers/i18n.js";
import "../../../../components/ana/components/ana-dialog/ana-dialog.styles.js";
import "../../../../components/ana/utils/shared/Modal.js";
import "../../../../components/ana/utils/fields/miscellaneous.js";
import "../../../../components/ana/utils/config/wishesAndExpectations.js";
import "../../../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../../components/website/common/button/styles.js";
import "../../../../components/website/jobs/job-description-section/styles.js";
import "../../../../components/website/jobs/job-details-hero-section/styles.js";
import "../../../../components/website/directions-section/styles.js";
import "react-headroom";
import "../../../../components/page-header/context/header-context.js";
import "../../../../components/page-header/components/header-skip/styles.js";
import "../../../../../components/expandable/expandable-dropdown/expandable-dropdown.styles.js";
import "../../../../../components/expandable/expandable-group/expandable-group-context.js";
import "../../../../components/page-header/page-header-mobile/page-header-mobile-content/styles.js";
import "query-string";
import "../../../../components/authentication/components/CredentialsProvider.js";
import "../../../../components/authentication/services/api.js";
import "../../../../components/authentication/components/RouterProvider.js";
import "../../../../components/authentication/components/SecurityConfigProvider.js";
import "../../../../components/authentication/services/i18n.js";
import "../../../../components/authentication/components/auth-container/auth-container.styles.js";
import "../../../../components/authentication/components/login-page/login-page.styles.js";
import "../../../../components/authentication/components/TrustedDeviceProvider.js";
import "../../../../components/authentication/components/HistoryProvider.js";
import { useDraggable } from "@dnd-kit/core";
import { GenericEventType, AppointmentState } from "../../appointment-schedule.types.js";
import { useAppointmentResize } from "../../hooks/useAppointmentResize.js";
import { useBlockerModalProvider } from "../../providers/blocker-modal-provider.js";
import { snapToGrid } from "./appointment.helpers.js";
import { Container, DetailsContainer, PatientName, AppointmentDivider, AppointmentTitle, TimeDetails, BlockerTitle, ResizeHandler } from "./appointment.styles.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "google-map-react";
import "../../../../components/obfuscated-text/obfuscated-text.styles.js";
import "../../../../components/pain-details-form/types.js";
import "../../../../components/task-form/assets/icons/Avatar.js";
import "../../../../components/task-form/assets/icons/Logo.js";
import "../../../../components/task-form/assets/icons/Comment.js";
import "../../../../components/task-form/task-form.helpers.js";
import "date-fns/locale";
import "../../../../components/task-form/task-form.types.js";
import "../../../../components/task-form/assets/icons/Important.js";
import "../../../../components/task-form/assets/icons/TaskCategory.js";
import "../../../../components/task-form/assets/icons/TaskDescription.js";
import "../../../../components/task-form/assets/icons/TaskName.js";
import "../../../../components/task-form/theme/overrides/Button.js";
import "../../../../components/task-form/theme/overrides/PickersLayout.js";
import "../../../../components/task-form/theme/overrides/Menu.js";
import "../../../../components/task-form/theme/overrides/Autocomplete.js";
import "../../../../../themes/icon-button/icon-button.js";
import "../../../../../themes/tabs/tabs.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.styles.js";
import "../../../../components/employee-select/assets/icons/Search.js";
import "../../../../components/employee-select/employee-select.styles.js";
import "../../../../components/employee-select/assets/icons/Arrow.js";
import "../../../../components/employee-select/assets/icons/Employees.js";
import "formik";
import "../../../../components/ana/utils/helpers/getHasError.js";
import "../../../../components/ana/utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../../../components/ana/utils/helpers/googlePlaces.js";
import "../../../../components/ana/utils/helpers/places.js";
import "../../../../../type/Appointment.js";
import "../../../../components/ana/components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../../../components/ana/utils/entities/Form.js";
import "../../../../components/ana/utils/helpers/toBoolean.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "../../../../components/ana/utils/helpers/createFields.js";
import "../../../../components/ana/utils/helpers/resetFields.js";
import "../../../../components/ana/utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../../../components/ana/utils/helpers/predicates.js";
import "../../../../components/ana/utils/yup/emailValidation.js";
import "../../../../components/ana/utils/helpers/featureFlags.js";
import "../../../../components/ana/utils/helpers/getAgeFromBirthday.js";
import "../../../../components/ana/utils/yup/buildValidationSchema.js";
import "../../../../../type/Disease.js";
import "../../../../components/ana/utils/config/medicaments.js";
import "../../../../components/ana/utils/fields/wishesAndExpectations.js";
import "../../../../components/ana/utils/fields/consents.js";
import "../../../../components/ana/utils/fields/profileInterest.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../../../components/ana/utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../../../components/ana/components/date-picker-field/date-picker-field.styles.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../../../components/ana/utils/helpers/phoneMetadata.js";
import "../../../../components/ana/components/phone-field/phone-field.styles.js";
import "../../../../components/ana/components/text-input/text-input.styles.js";
import "use-deep-compare";
import "fuse.js";
import "../../../../components/ana/components/insurance-field/insurance-field-helpers.js";
import "../../../../components/ana/components/insurance-field/Insurance-field.styles.js";
import "../../../../components/ana/utils/helpers/getIsRequired.js";
import "../../../../components/ana/components/form-layout/form-layout.js";
import "../../../../components/ana/utils/helpers/createField.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.js";
import "../../../../components/ana/components/select-field/select-field.js";
import "../../../../components/ana/components/select-input/select-input.js";
import "../../../../components/ana/components/text-field/text-field.js";
import "../../../../components/ana/components/submit-button/submit-button.js";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "../../../../../components/loader/loader.styles.js";
import "../../../../components/ana/utils/helpers/getFormInitialErrors.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.js";
import "../../../../components/ana/components/disease-field/disease-field.js";
import "../../../../components/ana/components/tag/tag.js";
import "@mui/icons-material/Cancel.js";
import "@mui/styles";
import "../../../../components/ana/components/disease-group-field/disease-group-field.helpers.js";
import "../../../../components/ana/utils/hooks/usePreConditionsToggle.js";
import "../../../../components/ana/utils/helpers/scrollToElementIfNotVisible.js";
import "../../../../components/ana/utils/helpers/isInViewport.js";
import "../../../../components/ana/forms/preconditions/preconditions.styles.js";
import "../../../../../type/Employee.js";
import "../../../../../utils/array.js";
import "fast-memoize";
import "../../../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "../../../../components/website/common/button/button.js";
import "../../../../../hooks/useResponsive.js";
import "../../../../components/smileview-section/hooks/useWindowSize.js";
import "../../../../components/authentication/config.js";
import "../../../../components/authentication/helpers/time.js";
import "../../../../components/authentication/hooks/useStickyState.js";
import "axios";
import "../../../../components/authentication/helpers/credentials.js";
import "../../../../components/authentication/helpers/headers.js";
import "@emotion/styled";
import "../../appointment-schedule.constants.js";
import "../blocker-modal/blocker-modal.js";
import "react-hook-form";
import "@mui/icons-material/CheckBox.js";
import "@mui/icons-material/CheckBoxOutlineBlank.js";
import "@mui/material/Checkbox/index.js";
import "../../../../../components/date-pickers/date-picker/date-picker.js";
import "@mui/x-date-pickers/AdapterDateFns/index.js";
import "@mui/x-date-pickers/DatePicker/index.js";
import "../../../../../components/time-interval-select/time-interval-select.js";
import "../../../../../components/time-select/time-select.js";
import "@mui/material/InputAdornment/index.js";
import "@mui/material/Typography/index.js";
import "../../../../../components/time-select/time-select.hepers.js";
import "../../../../../components/time-interval-select/time-interval-select.helpers.js";
import "../../../appointment-details/assets/icons/Date.js";
import "../../../appointment-details/assets/icons/Title.js";
import "../../../appointment-details/components/employee-autocomplete/employee-autocomplete.js";
import "@mui/icons-material";
import "../../../appointment-details/assets/icons/Employee.js";
import "../../../appointment-details/helpers/common.js";
import "../../../appointment-details/appointment-details.types.js";
import "../../../appointment-details/hooks/useEmployeeSearch.js";
import "@tanstack/react-query";
import "../../../appointment-details/providers/axios-provider.js";
import "../../../appointment-details/components/appointment-form/appointment-form.constants.js";
import "../../../appointment-details/components/appointment-form/appointment-form.helpers.js";
import "../../../appointment-details/helpers/appointment.js";
import "../../../appointment-details/components/employee-autocomplete/employee-autocomplete.skeleton.js";
import "../../../appointment-details/components/employee-autocomplete/employee-autocomplete.styles.js";
import "../../../../../utils/string/getNameInitials.js";
import "../../../../../utils/time/time.js";
import "../../hooks/useBlockerForm.js";
import "date-fns/startOfToday";
import "../../hooks/useSaveBlocker.js";
import "../../providers/axios-provider.js";
import "../../providers/working-times-provider.js";
import "../../helpers/getViewTimePeriod.js";
import "../../helpers/getEmptyCalendarSlots.js";
import "../../helpers/groupBy.js";
import "../../helpers/common.js";
import "../../helpers/fillEmptyDays.js";
import "../../hooks/useWorkingTimes.js";
import "../blocker-deletion-modal/blocker-deletion-modal.js";
import "../../hooks/useDeleteBlocker.js";
import "../blocker-deletion-modal/blocker-deletion-modal.styles.js";
import "../blocker-modal/blocker-modal.styles.js";
import "@mui/material/FormControlLabel/index.js";
import "../../helpers/hexToRgb.js";
const Appointment = ({
  labels,
  appointment,
  hasError,
  width,
  height,
  left,
  top,
  isPast: isPast$1,
  isSelected,
  isExtendedView,
  onClick,
  onResize,
  onResizeStart,
  onPatientClick,
  isObfuscated
}) => {
  var _a, _b, _c;
  const {
    patient,
    name,
    start,
    end,
    state,
    cancellationType,
    type,
    title,
    referenceId,
    risky: isRiskyAppointment
  } = appointment;
  const theme = useTheme();
  const difference = useMemo(() => differenceInMinutes(end, start), [start, end]);
  const blockerDifferenceLabel = difference >= 60 ? `${Math.floor(difference / 60)}${labels.hours} ${difference % 60}${labels.minutes}` : `${difference}${labels.minutes}`;
  const dragRef = useRef(null);
  const {
    isResizing,
    height: updatedHeight,
    timeDifference
  } = useAppointmentResize({ dragRef, onResize, onResizeStart, duration: difference });
  const { openModal: openBlockerModal } = useBlockerModalProvider();
  const isBlocker = type === GenericEventType.BLOCKER;
  const id = referenceId ?? `${name ?? title}-${start.toISOString()}`;
  const disableDragging = isPast$1 || isPast(end) || isBlocker || !!appointment.cancellationType || isResizing;
  const { attributes, listeners, setNodeRef, transform, isDragging, node } = useDraggable({
    id,
    disabled: disableDragging,
    data: appointment
  });
  const { x, y, timeSlotDifference } = snapToGrid(transform || void 0, node);
  const style = useMemo(
    () => ({
      ...transform && {
        transform: `translate(${x}px, ${y}px)`
      },
      ...isResizing && {
        height: `calc(${height}% + ${updatedHeight}px)`
      },
      ...(transform || isResizing) && {
        left: 0,
        zIndex: 10,
        boxShadow: "0px 4px 8px 3px rgba(0, 0, 0, 0.15)",
        cursor: "all-scroll"
      }
    }),
    [x, y, isDragging, isResizing, updatedHeight]
  );
  const updatedStartTime = add(start, { minutes: timeSlotDifference });
  const updatedEndTime = add(end, { minutes: timeSlotDifference || timeDifference });
  const updatedDuration = useMemo(
    () => differenceInMinutes(updatedEndTime, updatedStartTime),
    [updatedStartTime, updatedEndTime]
  );
  const formattedStart = useMemo(() => format(updatedStartTime, TIME_FORMATS.SHORT), [updatedStartTime]);
  const formattedEnd = useMemo(() => format(updatedEndTime, TIME_FORMATS.SHORT), [updatedEndTime]);
  const patientName = patient && `${patient.lastName}, ${(_a = patient.firstName) == null ? void 0 : _a.slice(0, 1)}.`;
  const isShort = updatedDuration < 30;
  const isExtraShort = updatedDuration < 15;
  const isSimpleView = isShort && !isExtendedView;
  const isTreated = (state === AppointmentState.TREATED || isPast$1) && !isExtendedView;
  const isOpenForAvailyBooking = !(appointment == null ? void 0 : appointment.blocking);
  const showTitle = !isResizing && !isDragging || isExtendedView || (isDragging || isResizing) && !isShort && !isExtendedView;
  const showExtraStartTime = isSimpleView && (isDragging || isResizing);
  const canResize = !isPast$1 && !appointment.cancellationType && !isDragging && !isBlocker && !!onResize;
  const handlePatientClick = (patientId) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    onPatientClick == null ? void 0 : onPatientClick(patientId);
  };
  const handleBlockerClick = (event) => {
    const blocker = {
      referenceId: appointment.referenceId,
      startDate: format(start, DATE_FORMATS.ISO_SHORT),
      startTime: format(start, TIME_FORMATS.SHORT),
      endTime: format(end, TIME_FORMATS.SHORT),
      employeeReferenceIds: [appointment.employeeReferenceId ?? ""],
      description: appointment.title,
      workRelated: appointment.workRelated
    };
    openBlockerModal(event.currentTarget, blocker);
  };
  const hints = useMemo(() => {
    var _a2;
    const qaKeys = Object.values(((_a2 = appointment == null ? void 0 : appointment.additionalAppointmentHints) == null ? void 0 : _a2.hints) ?? {}).flat();
    return qaKeys.reduce(
      (acc, pain) => `${acc}
${labels.pain.questions[pain.questionContentfulKey]}: ${labels.pain.answers[pain.answerContentfulKey]}`,
      ""
    );
  }, [(_b = appointment == null ? void 0 : appointment.additionalAppointmentHints) == null ? void 0 : _b.hints, labels.pain]);
  const notes = `${appointment.comment || ""}${hints || ""}`.trim();
  const showComment = Boolean(notes) && !isShort;
  const disableTooltip = !isRiskyAppointment && !notes || Boolean(notes) && !isShort;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    isDragging && /* @__PURE__ */ jsxs(
      Container,
      {
        width,
        height,
        top,
        left,
        isTreated: true,
        isCancelled: !!cancellationType,
        isBlocker,
        hasError,
        colorCode: appointment.colorCode,
        colorBackground: isOpenForAvailyBooking ? theme.palette.secondary[25] : void 0,
        isShort,
        disableRipple: true,
        disableTouchRipple: true,
        disableFocusRipple: true,
        children: [
          /* @__PURE__ */ jsxs(DetailsContainer, { isShort, children: [
            patientName && /* @__PURE__ */ jsx(PatientName, { variant: "Lato Caption Bold", isShort, children: /* @__PURE__ */ jsx(ObfuscatedText, { isVisible: !isObfuscated, children: patientName }) }),
            showTitle && /* @__PURE__ */ jsxs(Fragment, { children: [
              isSimpleView && /* @__PURE__ */ jsx(AppointmentDivider, { variant: "Lato Caption Small", margin: 4, children: "|" }),
              /* @__PURE__ */ jsx(AppointmentTitle, { variant: "Lato Caption Small", isShort, children: name })
            ] })
          ] }),
          !isSimpleView && /* @__PURE__ */ jsx(Typography, { variant: "Lato Overline Bold", children: `${formattedStart} - ${formattedEnd}` })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      Container,
      {
        ref: setNodeRef,
        style,
        ...listeners,
        ...attributes,
        width,
        height,
        top,
        left,
        isTreated,
        isCancelled: !!cancellationType,
        isBlocker,
        hasError,
        colorCode: appointment.colorCode,
        isRiskyAppointment,
        colorBackground: isOpenForAvailyBooking ? theme.palette.secondary[25] : void 0,
        isShort,
        isDragging,
        isResizing,
        isSelected,
        disabled: isResizing,
        disableRipple: true,
        disableTouchRipple: true,
        disableFocusRipple: true,
        ...!isBlocker && !isResizing && {
          onClick
        },
        ...isBlocker && appointment.referenceId && {
          onClick: handleBlockerClick
        },
        children: [
          !isBlocker && /* @__PURE__ */ jsx(
            StyledTooltip,
            {
              disableHoverListener: disableTooltip,
              title: /* @__PURE__ */ jsxs(Fragment, { children: [
                isRiskyAppointment && /* @__PURE__ */ jsx(Typography, { component: "p", variant: "Lato Caption", children: labels.unconfirmed }),
                Boolean(notes) && /* @__PURE__ */ jsx(Typography, { component: "p", variant: "Lato Caption", children: notes })
              ] }),
              placement: "bottom-start",
              children: /* @__PURE__ */ jsxs(DetailsContainer, { isShort, children: [
                patientName && /* @__PURE__ */ jsx(
                  PatientName,
                  {
                    variant: "Lato Caption Bold",
                    isShort,
                    onClick: handlePatientClick((_c = appointment.patient) == null ? void 0 : _c.referenceId),
                    children: /* @__PURE__ */ jsx(ObfuscatedText, { isVisible: !isObfuscated, children: patientName })
                  }
                ),
                showTitle && /* @__PURE__ */ jsxs(Fragment, { children: [
                  isSimpleView && /* @__PURE__ */ jsx(AppointmentDivider, { variant: "Lato Caption Small", margin: 4, children: "|" }),
                  /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [
                    showComment && /* @__PURE__ */ jsx(StyledTooltip, { title: /* @__PURE__ */ jsx(Typography, { variant: "Lato Caption", children: notes }), children: /* @__PURE__ */ jsx(
                      SvgIcon,
                      {
                        component: CommentIcon,
                        sx: {
                          mr: theme.spacing(0.5),
                          width: "14px",
                          height: "14px",
                          color: theme.palette.grey[800]
                        },
                        fill: theme.palette.grey[800]
                      }
                    ) }),
                    /* @__PURE__ */ jsxs(
                      AppointmentTitle,
                      {
                        isRiskyAppointment,
                        variant: "Lato Caption Small",
                        isShort,
                        isDragging,
                        children: [
                          isRiskyAppointment && /* @__PURE__ */ jsx(WarningIcon, { sx: { mr: "2px" }, size: "xs", fill: theme.palette.secondary[500] }),
                          name
                        ]
                      }
                    )
                  ] })
                ] }),
                showExtraStartTime && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(AppointmentDivider, { variant: "Lato Caption Small", margin: 4, children: "|" }),
                  /* @__PURE__ */ jsx(TimeDetails, { variant: "Lato Overline Bold", children: formattedStart })
                ] })
              ] })
            }
          ),
          (!isSimpleView || isBlocker) && /* @__PURE__ */ jsx(Typography, { variant: "Lato Overline Bold", children: `${formattedStart} - ${formattedEnd}` }),
          isBlocker && !isExtraShort && /* @__PURE__ */ jsx(BlockerTitle, { variant: "Lato Overline Bold", isExtended: !!isExtendedView, children: `${title ?? labels.blocker} (${blockerDifferenceLabel})` }),
          canResize && /* @__PURE__ */ jsx(ResizeHandler, { ref: dragRef })
        ]
      }
    )
  ] });
};
export {
  Appointment
};
